<ng-container *ngIf="items">
  <mb-section-headline [headline]="headline" [anchor]="anchor">
    <mb-dropdown
      [hideLabel]="true"
      class="d-md-none"
      [class.active]="activeFilter && activeFilter.value !== 'ALL'"
      [value]="activeFilter?.value"
      [options]="filters"
      [icon]="activeFilter?.value === 'ALL' ? 'mb-icon-filter' : 'mb-icon-filter-flat'"
      (selectionChanged)="filter($event)"
    ></mb-dropdown>
  </mb-section-headline>

  <mb-ribbon-slider-section
    class="show-navigation"
    [config]="config"
    [itemWrapperClasses]="['col-12 col-xs-6 col-md-4 col-lg-3']"
    [items]="activeTeasers"
    [filters]="filters"
    (filtered)="filter($event)"
    [stickyFilters]="stickyFilters"
    [mobileFilter]="false"
    [filterWrapperClasses]="['col-2']"
    [placeholderOffsetItemClasses]="placeholderOffsetItemClasses"
    containerClass="container-sm"
  >
    <ng-template #itemTemplate let-item="item" let-index="index">
      <a *ngIf="sectionId" [routerLink]="['test-cars', sectionId]" [queryParams]="{ car: index }">
        <mb-test-car-card [data]="item"></mb-test-car-card>
      </a>
      <mb-test-car-card *ngIf="!sectionId" [data]="item"></mb-test-car-card>
    </ng-template>
  </mb-ribbon-slider-section>
</ng-container>
